/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PlayerMeasurementRow = {
    source: string;
    measurement: PlayerMeasurementRow.measurement;
    unit: PlayerMeasurementRow.unit;
    value: number;
    measuredAt: string;
};
export namespace PlayerMeasurementRow {
    export enum measurement {
        HAND_LENGTH = 'HAND_LENGTH',
        LANE_AGILITY_MODIFIED = 'LANE_AGILITY_MODIFIED',
        SHUTTLE = 'SHUTTLE',
        RUN_THREE_FOUR = 'RUN_THREE_FOUR',
        HEIGHT_W_SHOES = 'HEIGHT_W_SHOES',
        V_SIT_REACH = 'V_SIT_REACH',
        VERTICAL_JUMP_MAX = 'VERTICAL_JUMP_MAX',
        WINGSPAN = 'WINGSPAN',
        WEIGHT = 'WEIGHT',
        HAND_WIDTH = 'HAND_WIDTH',
        LANE_AGILITY = 'LANE_AGILITY',
        STANDING_REACH = 'STANDING_REACH',
        RUN_ONE_TWO = 'RUN_ONE_TWO',
        PULL_UP = 'PULL_UP',
        BODY_FAT = 'BODY_FAT',
        VERTICAL_JUMP_NO_STEP = 'VERTICAL_JUMP_NO_STEP',
        MILE = 'MILE',
        BENCH_PRESS = 'BENCH_PRESS',
        HEIGHT_BAREFOOT = 'HEIGHT_BAREFOOT',
    }
    export enum unit {
        SECONDS = 'SECONDS',
        REPS = 'REPS',
        LBS = 'LBS',
        INCHES = 'INCHES',
        PERCENT = 'PERCENT',
        UNKNOWN = 'UNKNOWN',
    }
}

